/**
 * Sitewide accessibility options
 */
const accessibilitySetup = () => {

    // Accessibility
    // Current font in localstorage is --font-size-tablet
    function getFontPropertyValue(property) {
        return getComputedStyle(document.documentElement)
            .getPropertyValue(property)
            .slice(0, -2)
    }

    const decreaseFontEl = document.querySelector('.fontSize .decrease')
    const increaseFontEl = document.querySelector('.fontSize .increase')
    const resetFont = document.querySelector('.fontSize .reset')

    function setCurrentFont(savedFontSize = null) {
        if (savedFontSize) {
            document.documentElement.style.setProperty(
                '--font-size',
                `${savedFontSize - 2}px`
            )
            document.documentElement.style.setProperty(
                '--font-size-tablet',
                `${savedFontSize}px`
            )
        }
    }

    // run this on every page load
    setCurrentFont(localStorage.getItem('font-size'))

    function updateFontLocal(size) {
        return localStorage.setItem('font-size', size)
    }

    resetFont.addEventListener('click', function () {
        resetFontSize()
    })
    resetFont.addEventListener('keydown', function (e) {
        if (e.key == ' ' || e.key == 'Enter') {
            resetFontSize()
        }
    })
    function resetFontSize() {
        const resetFontSize = getFontPropertyValue('--default-size')
        const resetFontSizeTablet = getFontPropertyValue(
            '--default-size-tablet'
        )

        document.documentElement.style.setProperty(
            '--font-size',
            `${resetFontSize}px`
        )
        document.documentElement.style.setProperty(
            '--font-size-tablet',
            `${resetFontSizeTablet}px`
        )

        updateFontLocal(resetFontSizeTablet)
    }

    function decreaseFont() {
        let currentFont = getFontPropertyValue('--font-size')
        let currentFontTablet = getFontPropertyValue('--font-size-tablet')

        if (currentFont !== 'NaN') {
            document.documentElement.style.setProperty(
                '--font-size',
                `${currentFont - 1}px`
            )
        } else {
            const resetFontSize = getFontPropertyValue('--default-size')
            document.documentElement.style.setProperty(
                '--font-size',
                `${resetFontSize - 1}px`
            )
        }

        if (currentFontTablet !== 'NaN') {
            document.documentElement.style.setProperty(
                '--font-size-tablet',
                `${currentFontTablet - 1}px`
            )
        } else {
            const resetFontSizeTablet = getFontPropertyValue(
                '--default-size-tablet'
            )
            document.documentElement.style.setProperty(
                '--font-size-tablet',
                `${resetFontSizeTablet - 1}px`
            )
            currentFontTablet = resetFontSizeTablet
        }
        updateFontLocal(Number.parseInt(currentFontTablet) - 1)
    }

    function increaseFont() {
        let currentFont = getFontPropertyValue('--font-size')
        let currentFontTablet = getFontPropertyValue('--font-size-tablet')
        if (currentFontTablet !== 'NaN') {
            document.documentElement.style.setProperty(
                '--font-size',
                `${Number.parseInt(currentFont) + 1}px`
            )
        } else {
            const resetFontSize = getFontPropertyValue('--default-size')
            document.documentElement.style.setProperty(
                '--font-size',
                `${resetFontSize + 1}px`
            )
        }
        if (currentFontTablet !== 'NaN') {
            document.documentElement.style.setProperty(
                '--font-size-tablet',
                `${Number.parseInt(currentFontTablet) + 1}px`
            )
        } else {
            const resetFontSize = getFontPropertyValue('--default-size-tablet')
            document.documentElement.style.setProperty(
                '--font-size-tablet',
                `${resetFontSize}px`
            )
            currentFontTablet = resetFontSize
        }
        updateFontLocal(Number.parseInt(currentFontTablet) + 1)
    }

    increaseFontEl.addEventListener('click', increaseFont)
    decreaseFontEl.addEventListener('click', decreaseFont)
    decreaseFontEl.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            decreaseFont()
        }
    })

    increaseFontEl.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            increaseFont()
        }
    })

    const contrastToggle = document.querySelector(
        '.accessibilityControls .contrast'
    )
    const body = document.querySelector('body')

    function setCurrentContrast() {
        if (localStorage.getItem('contrast')) {
            body.classList.add('isHighContrast')
        } else {
            body.classList.remove('isHighContrast')
        }
    }

    function handleContrastToggle() {
        if (localStorage.getItem('contrast')) {
            localStorage.removeItem('contrast')
            setCurrentContrast()
        } else {
            localStorage.setItem('contrast', true)
            setCurrentContrast()
        }
    }
    setCurrentContrast()

    contrastToggle.addEventListener('click', handleContrastToggle)

    contrastToggle.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            handleContrastToggle()
        }
    })
}

export default accessibilitySetup